export default __webpack_public_path__ + "static/media/560.f77304f7.jpg";